import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { useTheme } from '../theme-context';
import { useAppDispatch } from '../app/hooks';
import Sidebar from './layout-components/Sidebar';
// import Profile from './layout-components/Profile';
import RightSidebar from './layout-components/RightSidebar';
import ChatDrawer from '../components/search-chat/chat';
import SearchInput from '../shared/chat-bar/search-input';
import { CHAT_ACTIONS } from '../utils/constants/chat-actions';
import NewChatModal from '../components/new-chat/NewChatModal';
import { tryToFetchTeamMembersSidebar } from '../store/brokers/partners/teams/teamsSlice';
import { tryToFetchActivities } from '../store/brokers/partners/activities/activititesSlice';
import { tryToFetchNotifications } from '../store/brokers/partners/notifications/notificationsSlice';
import { tryToCreateChatMessage } from '../store/brokers/partners/chats/ChatsSlice';

const Layout = () => {
    const dispatch = useAppDispatch()
    const location: any = useLocation();
    const { theme } = useTheme();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [rightSidebarOpen, setRightSidebarOpen] = useState(false);
    const [chatOpen, setChatOpen] = useState<{ show: boolean, data: any, action?: any, chatId?: string }>()
    const [chatData, setChatData] = useState<any>();
    const [chatIsWaiting, setChatIsWaiting] = useState<boolean>(false)
    const [showSearchChat, setShowSearchChat] = useState<boolean>(false);

    const onOpenChat = async (data?: any, chatId?: string) => {
        try {
            if (data) {

                setChatIsWaiting(true)
                const formatData = {
                    chatData: {
                        message: data?.user?.message,
                        files: data?.user?.files
                    }
                };
                const response = await dispatch(tryToCreateChatMessage(formatData)).unwrap();
                const formData = [
                    {
                        agent: {
                            message: response?.data?.metadata?.preActionMessage?.agent?.message,
                            files: [],
                            createdAt: new Date(),
                            _id: response?.data?.metadata?.messageId,
                        }
                    },
                    {
                        user: data?.user
                    },
                    {
                        agent: {
                            message: response?.data?.chatData?.agent?.message,
                            files: response?.data?.chatData?.agent?.files || [],
                            createdAt: new Date(),
                            _id: response?.data?.metadata?.messageId,
                        }
                    }
                ]
                setChatData(formData);
                setSidebarOpen(false);
                setChatOpen({
                    show: true,
                    data: formData || [],
                    chatId: response?.data?.metadata.topic || chatId || undefined,
                    action: undefined
                });
            } else {
                setSidebarOpen(false);
                setChatData(undefined)
                setChatOpen({
                    show: true,
                    data: [],
                    chatId: chatId || undefined,
                    action: undefined
                });
            }
        } catch (err) {
            console.error(err)
        }
        setChatIsWaiting(false)
    };

    const onClickAction = (action: any) => {
        setRightSidebarOpen(false)
        const formatUserRequest = {
            user: {
                message: action.text,
                files: [],
                sort: 2
            }
        };
        setChatData([]);
        setChatOpen({
            show: true,
            data: [formatUserRequest],
            action: action
        });
    };

    const onClickShowModal = () => {
        setSidebarOpen(false)
        setShowSearchChat(!showSearchChat)
    }

    const onTryingToOpenChat = (id?: string, action?: any) => {
        setShowSearchChat(false)
        if (action) {
            onClickAction(action)
            setChatData([])
        } else {
            onOpenChat(undefined, id)
            setChatData([])
        }
    }

    const onGettingData = async () => {
        try {
            const data = {
                pageSize: 5,
                pageNumber: 1
            }
            await dispatch(tryToFetchTeamMembersSidebar(data)).unwrap();
            await dispatch(tryToFetchActivities(data)).unwrap();
            await dispatch(tryToFetchNotifications(data)).unwrap();
        } catch (err) {
            console.error(err)
        }
    }

    useEffect(() => {
        if (!chatOpen) {
            onGettingData()
        }
    }, [chatOpen])

    const onCloseChat = () => {
        setChatOpen(undefined)
        setChatData(undefined)
    }

    return (
        <div className='bg-white flex flex-col min-h-screen'>
            {/* <Transition.Root show={sidebarOpen} as={Fragment}>
                <Dialog
                    as='div'
                    className='relative z-40 md:hidden'
                    onClose={setSidebarOpen}
                >
                    <Transition.Child
                        as={Fragment}
                        enter='transition-opacity ease-linear duration-300'
                        enterFrom='opacity-0'
                        enterTo='opacity-100'
                        leave='transition-opacity ease-linear duration-300'
                        leaveFrom='opacity-100'
                        leaveTo='opacity-0'
                    >
                        <div className='fixed inset-0 bg-gray-600 bg-opacity-75' />
                    </Transition.Child>

                    <div className='fixed inset-0 flex z-40'>
                        <Transition.Child
                            as={Fragment}
                            enter='transition ease-in-out duration-300 transform'
                            enterFrom='-translate-x-full'
                            enterTo='translate-x-0'
                            leave='transition ease-in-out duration-300 transform'
                            leaveFrom='translate-x-0'
                            leaveTo='-translate-x-full'
                        >
                            <Dialog.Panel className='relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4'>
                                <Transition.Child
                                    as={Fragment}
                                    enter='ease-in-out duration-300'
                                    enterFrom='opacity-0'
                                    enterTo='opacity-100'
                                    leave='ease-in-out duration-300'
                                    leaveFrom='opacity-100'
                                    leaveTo='opacity-0'
                                >
                                    <div className='absolute top-0 right-0 -mr-12 pt-2'>
                                        <button
                                            type='button'
                                            className='ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white'
                                            onClick={() => setSidebarOpen(false)}
                                        >
                                            <span className='sr-only'>Close sidebar</span>
                                            <img src='/assets/shared/close-grey.svg' alt='close' />
                                            <span className='h-6 w-6 text-white' aria-hidden='true' />
                                        </button>
                                    </div>
                                </Transition.Child>
                                <div className='flex-shrink-0 flex items-center px-4 mb-10'>
                                    <NavLink to='/'>
                                        <img className='max-h-8 w-auto' src='/assets/auth/navigation-logo.svg' alt='logo' />
                                    </NavLink>
                                </div>
                                <div className='mt-5 flex-1 h-0 overflow-y-auto'>
                                    <nav className='px-2 space-y-1'>
                                        <Navigation />
                                    </nav>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                        <div className='flex-shrink-0 w-14' aria-hidden='true'></div>
                    </div>
                </Dialog>
            </Transition.Root> */}
            {sidebarOpen && (
                <div className="fixed inset-0 z-40 flex md:hidden">
                    <div className="fixed inset-0 bg-black bg-opacity-50" onClick={() => setSidebarOpen(false)}></div>

                    <div className="relative bg-white w-70 h-full shadow-xl z-50 overflow-y-auto">
                        <div className="flex justify-end p-3 pr-[10px]">
                            <button onClick={() => setSidebarOpen(false)}>
                                <img src="/assets/shared/close-grey.svg" alt="Close" className="w-5 h-5" />
                            </button>
                        </div>

                        <Sidebar onClickShowModal={onClickShowModal} onClickOpenChat={onOpenChat} isMobile={true} />
                    </div>
                </div>
            )}
            <Sidebar
                onClickShowModal={onClickShowModal}
                onClickOpenChat={onOpenChat}
            />

            <div className='flex flex-col flex-1 md:px-64'>
                {/* <header className='sticky top-0 z-20 flex-shrink-0 flex bg-white p-4 h-20'>
                    <button
                        type='button'
                        className='px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden'
                        onClick={() => setSidebarOpen(true)}
                    >
                        <span className='sr-only'>Open sidebar</span>
                        <img src='/assets/navigation/list.svg' alt='' />
                    </button>
                    <div className='flex-1 pr-4 flex justify-between'>
                        <div className='flex-1 flex flex-row justify-between'>
                            <Profile />
                            <div className='hidden md:flex md:ml-0 my-auto'>
                                <img src={'/assets/chat/hotelworld-logo.svg'} className='object-contain h-[30px]' />
                            </div>
                        </div>
                    </div>
                </header> */}

                <header className='sticky top-0 z-10 flex-shrink-0 flex bg-white dark:bg-bgColor-darkMode p-4 h-16 md:hidden justify-between'>
                    <button
                        type='button'
                        className=' text-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 px-1 '
                        onClick={() => setSidebarOpen(true)}
                    >
                        <img src={theme === 'dark' ? '/assets/navigation-icons/burger-menu-white.svg' : '/assets/navigation-icons/burger-menu.svg'} className='object-contain w-[23px]' />
                    </button>
                    <button
                        type='button'
                        className=' text-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 px-1 '
                        onClick={() => setRightSidebarOpen(true)}
                    >
                        <img src={theme === 'dark' ? '/assets/navigation-icons/left-side-arrow-white.svg' : '/assets/navigation-icons/left-side-arrow.svg'} className='object-contain w-[23px]' />
                    </button>
                </header>

                {/* <div className='flex flex-col flex-1 md:px-64'> */}
                <main className='flex-1 relative'>
                    <AnimatePresence mode="wait">
                        {chatOpen && location?.pathname === '/insights' ? (
                            <ChatDrawer
                                key="chat"
                                isOpen={chatOpen?.show}
                                chatData={chatOpen?.data}
                                action={chatOpen?.action}
                                historyId={chatOpen?.chatId}
                                onClose={onCloseChat}
                                triggerId="sofia-chat"
                            />
                        ) : (
                            <motion.div
                                key="input"
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -10 }}
                                transition={{ duration: 0.3 }}
                                className=""
                            >
                                {location?.pathname === '/insights' &&
                                    < div className='py-5 px-4 bg-[#F5F5F5] dark:bg-[#191919] min-w-full'>
                                        <SearchInput
                                            placeholder={'Ask Sofia for something'}
                                            chatData={chatData || []}
                                            chatId={chatOpen?.chatId}
                                            considerDarkMode={true}
                                            isWaiting={chatIsWaiting}
                                            onSendingData={onOpenChat}
                                        />
                                        <p className='my-5 font-semibold dark:text-primary-dark'>Actions</p>
                                        <div className='flex flex-row items-center flex-wrap gap-2'>
                                            {CHAT_ACTIONS?.map((item: any, idx: number) => {
                                                return (
                                                    <div
                                                        key={idx}
                                                        onClick={() => onClickAction(item)}
                                                        className='mr-1 rounded-full cursor-pointer hover:opacity-80 py-1 px-3 bg-[#252B37] dark:bg-black text-white text-center'>
                                                        <p className='font-bold text-sm'>{item?.name}</p>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                }
                                <div className='px-5 py-4 dark:bg-bgColor-darkMode'>
                                    <Outlet />
                                </div>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </main>
                {/* </div> */}
            </div>
            {
                rightSidebarOpen && (
                    <div className="fixed inset-0 z-40 flex md:hidden">
                        <div className="fixed inset-0 bg-black bg-opacity-50" onClick={() => setRightSidebarOpen(false)}></div>

                        <div className="relative bg-white dark:bg-bgColor-darkMode w-70 h-full shadow-xl z-50 overflow-y-auto">
                            <div className="flex justify-end p-3 pr-[10px]">
                                <button onClick={() => setRightSidebarOpen(false)}>
                                    <img src="/assets/shared/close-grey.svg" alt="Close" className="w-5 h-5" />
                                </button>
                            </div>
                            <RightSidebar
                                onClickOpenChat={onClickAction}
                                isMobile={true}
                            />
                        </div>
                    </div>
                )
            }
            <RightSidebar
                onClickOpenChat={onClickAction}
            />
            {
                showSearchChat &&
                <NewChatModal
                    openModal={showSearchChat}
                    handleCloseModal={onClickShowModal}
                    onClickOpenChat={onTryingToOpenChat}
                />
            }
        </div >
    );
};

export default Layout;
